import { createStore, compose, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';

export default function configureStore(initialState) {
    if (process.env.NODE_ENV === 'production') {
        return createStore(rootReducer, initialState, applyMiddleware(
            thunkMiddleware
        ));
    }

    let middleware = applyMiddleware(
        thunkMiddleware
    );

    if (typeof window.devToolsExtension !== 'undefined') {
        middleware = compose(
            applyMiddleware(
                thunkMiddleware
            ),
            window.devToolsExtension()
        );
    }

    const store = createStore(
        rootReducer,
        initialState,
        middleware
    );

    if (module.hot) {
        module.hot.accept('../reducers/index', () =>
            store.replaceReducer(require('../reducers/index').default)
        );
    }

    return store;
}
